import { render } from "./AdminTopbar.vue?vue&type=template&id=61457aea"
import script from "./AdminTopbar.vue?vue&type=script&lang=js"
export * from "./AdminTopbar.vue?vue&type=script&lang=js"

import "./AdminTopbar.vue?vue&type=style&index=0&id=61457aea&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__